import { Stack } from "@mui/material";
import type { HunterDetailDto } from "Infrastructure/Api/Api";
import { ContactInfoSection } from "./ContactInfoSection";
import { LicensesSection } from "./LicensesSection";
import { PartyInfoSection } from "./PartyInfoSection";
import { UserInfoSection } from "./UserInfoSection";

type Props = {
  hunter: HunterDetailDto;
};

export const HunterReadOnlyDetail = ({ hunter }: Props) => (
  <Stack gap={5}>
    <UserInfoSection hunter={hunter} />
    {hunter.party && (
      <>
        <PartyInfoSection party={hunter.party} />
        <ContactInfoSection party={hunter.party} />
        <LicensesSection licenses={hunter.party.licenses} />
      </>
    )}
  </Stack>
);
